import React from 'react';

import Slider from './Slider.style';

type SliderProps = React.ComponentProps<typeof Slider>;

interface FontSizeSelectorProps extends Pick<SliderProps, 'onChange' | 'value'> {
    color?: string;
}

const FontSizeSelector: React.FC<FontSizeSelectorProps> = ({ onChange, color, value }) => {
    const style = { color: color ? color : 'black' };

    return (
        <Slider
            style={{ width: '100%' }}
            step={10}
            defaultValue={100}
            value={value}
            min={50}
            max={150}
            marks={{ 50: { label: '50%', style }, 100: { label: '100%', style }, 150: { label: '150%', style } }}
            onChange={onChange}
        />
    );
};

export default React.memo(FontSizeSelector);
export { FontSizeSelectorProps };
